<template>
  <div class="md-layout md-alignment-top-center">
    <div class="md-layout-item md-size-95">
      <p>{{boxPlaceName}}</p>
      <template v-for="condition in conditions">
        <QuantityCheckGroup
          :maintenanceId=maintenanceId
          :condition=condition
          :type=type
          @changeCheckbox=changeCheckbox
          @finish="finish"
        >
        </QuantityCheckGroup>
      </template>
      <button class="btn btn-lg btn-outline-dark btn-block" @click="back">一覧に戻る</button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import QuantityCheckGroup from '@/components/parts/QuantityCheckGroup';

  export default {
    name: 'QuantityCheck',
    computed: {
      ...mapGetters([
        'boxPlaceName'
      ]),
    },
    components: {
      QuantityCheckGroup,
    },
    props: {
      maintenanceId: Number,
      normalTemperatureItems: {},
      refrigeratedItems: {},
      checkList: {},
      type: String,
    },
    data() {
      return {
        conditions: [
          {
            items: this.normalTemperatureItems,
            id: 1,
            name: '常温',
            checkList: this.checkList[1],
          },
          {
            items: this.refrigeratedItems,
            id: 2,
            name: '冷蔵',
            checkList: this.checkList[2],
          },
        ]
      };
    },
    methods: {
      finish: function(conditionTypeId) {
        this.$emit('finish', conditionTypeId);
      },
      back: function() {
        this.$emit('back');
      },
      changeCheckbox: function(e, conditionTypeId, itemId) {
        this.$emit('changeCheckbox', e, conditionTypeId, itemId);
      },
    },
  };
</script>

<style lang="scss" scoped>
  p {
    text-align: left;
    font-weight: bold;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/QuantityCheck.vue?ebe828be